import { render } from "./GeteyesIntroduction.vue?vue&type=template&id=72189ec9"
import script from "./GeteyesIntroduction.vue?vue&type=script&lang=js"
export * from "./GeteyesIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__